import React, {Component} from "react"

import {Entity} from "aframe-react"

import {
    startSpeech,
    stopSpeech,
    abortSpeech,
} from "../actions/microphone";

import {
    stopInput,
} from "../actions"

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import FadeAnimation from "./FadeAnimation"

class InnerSpehere extends Component {

    constructor(props) {
        super(props)

        this.state = {
            visible: false,
        }
    }

    render() {
        return (
            <Entity

                    id="small-sphere"

                    visible={this.state.visible}
                    
                    geometry={{
                        primitive: "sphere",
                        radius: 10,
                        segmentsHeight: 16, //10,
                        segmentsWidth: 32 //16,

                    }}

                    position={{
                        x: 0, y: 0, z: 0
                    }}

                    material={{ 
                        color: "#000", 
                        side: "back", 
                        shader: "flat",
                        transparent: true,

                        opacity: 0, //0.8, 
                    }}

                    scale={{x: 1, y: 1, z: 1}}

                    frame-button={{
                        button: true,
                        cursorFeedback: false,
                    }}

                    events={{

                        clickUp: () => {
                            // this.props.stopSpeech()
                            this.props.stopInput()
                        },

                        animationstart: (e) => {
                            console.log("start", e.target.id)

                            if (e.target.id !== "sphere-fade-in") return

                            this.setState({
                                visible: true,
                            })
                            
                        },

                        animationend: (e) => {
                            console.log("end", e.target.id)

                            if (e.target.id !== "sphere-fade-out") return

                            console.log(this.setState({
                                visible: false,
                            }))
                        }
                    }}

                >
                     <FadeAnimation  
                        dur={700}
                        min={0} max={0.6}

                        id="sphere-fade-in"

                        begin="sphereopen"
                        end="sphereclose"
                     /> 
                     <FadeAnimation  
                        dur={700}
                        min={0} max={0.6}

                        id="sphere-fade-out"

                        begin="sphereopen"
                        end="sphereclose"

                        reverse={true}
                     /> 
                </Entity> 
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        startSpeech: startSpeech,
        stopSpeech: stopSpeech,
        abortSpeech: abortSpeech,
        stopInput: stopInput,
    }, dispatch);
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(InnerSpehere);

// export default InnerSpehere


// WEBPACK FOOTER //
// ./src/components/inner-sphere.js